import { tourID } from "../../../setScene";
import { tourExists } from "../../../socket/socketHelper";

export let _model;
export const setmodel = (model) => {
  _model = model;

}